import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './ProductDescription.styled';
import sanitizeHTML from '../../../../util/sanitize-html';

/**
 * A `ProductDescription` displays a product's description as HTML.
 */
const ProductDescription = ({ className, description }) => (
  <Styled.ProductDescription
    className={className}
    data-testid="productDescription"
    dangerouslySetInnerHTML={{ __html: sanitizeHTML(description) }}
  />
);

ProductDescription.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string.isRequired
};

ProductDescription.defaultProps = {
  className: null
};

export default ProductDescription;
